module.exports = __webpack_public_path__ + "img/Household.1698d5b1.svg";